export const reservasModals = {
  roomChange: {
    close: "Zamknij",
    titleAssign: "Przypisz pokój",
    titleChange: "Zmień pokój",
    stopSoldNote:
      "Ten typ pokoju jest zamknięty dla sprzedaży w tych terminach (stop-sell), ale pokoje nadal można reorganizować: przeniesienie ani przypisanie nie wznowi sprzedaży.",
    labelAssign: "Pokój do przypisania",
    labelNew: "Nowy pokój",
    selectPlaceholder: "Proszę wybrać pokój…",
    swapWith: "Zamiana z: {names}",
    swapWithType: "Zamiana z: {names} (przechodzi do {type})",
    swapTypeWarning: "Po zamianie {names} przechodzi do {type}, co nie jest zarezerwowanym typem.",
    swapGroup:
      "Zamiana grupowa: {name} oraz {also} przechodzą do tamtego pokoju, a {incoming} przechodzą do obecnego. Wszystko w jednej operacji.",
    swapSingle:
      "Tamten pokój jest zajęty, goście: {names}. Po zapisaniu nastąpi {action}: ta rezerwacja przechodzi do tamtego pokoju, a pozostałe do obecnego.",
    swapWord: "zamiana",
    emptyNote:
      "Żaden pokój nie jest wolny w całym zakresie. Proszę użyć przycisku «{action}» na torze «Do uporządkowania», aby automatycznie przestawić rezerwacje.",
    organizeWord: "Uporządkuj",
    sameTypeGroup: "Ten sam typ · {name}",
    otherTypeGroup: "Inny typ · {name}",
    typeChangeNote:
      "Rezerwacja zostanie przeniesiona do typu: {type}. Jej dane są aktualizowane, dostępność obu typów zostaje przeliczona, a kanały otrzymują powiadomienie.",
    selectRoomError: "Należy wybrać pokój",
    cancel: "Anuluj",
    confirmSwap: "Zamień",
    confirmAssign: "Przypisz",
    confirmSave: "Zapisz zmianę",
  },
  outOfOrder: {
    titleMaintenance: "Konserwacja pokoju",
    titleActions: "Akcje typu pokoju",
    scopeLabel: "Zakres",
    scopeUnit: "Typ pokoju (wszystkie)",
    scopeInstance: "Ten pokój",
    actionLabel: "Akcja",
    actionOoo: "Wyłączony z użytku (konserwacja)",
    actionOpen: "Otwórz ponownie w zakresie",
    quantityLabel: "Liczba pokoi",
    maxPerDay: "Maksymalnie {max} dziennie.",
    dateRangeLabel: "Zakres dat",
    from: "Od",
    to: "Do",
    cancel: "Anuluj",
    apply: "Zastosuj",
  },
  closeDay: {
    title: "Zmień dostępność",
    syncing: "Synchronizowanie dostępności...",
    roomTypeLabel: "Typ pokoju",
    roomTypePlaceholder: "Proszę wybrać pokój",
    startDate: "Data początkowa",
    endDate: "Data końcowa",
    maxAvailable: "Maksymalnie: {count} dostępnych",
    cancel: "Anuluj",
    apply: "Zastosuj zmianę",
  },
  confirm: {
    defaultTitle: "Potwierdzić?",
    confirm: "Potwierdź",
    cancel: "Anuluj",
  },
  updateAlert: {
    title: "Aktualizuj pokój",
    sectionTitle: "Informacje o pokoju",
    nameLabel: "Nazwa lub numer pokoju",
    keyLabel: "Kod dostępu",
    cancel: "Anuluj",
    submit: "Aktualizuj pokój",
    nameRequired: "Nazwa lub numer pokoju jest wymagany",
  },
};
